
export default {
    name: 'atBox',
    props: ['selectionStart', 'comments', 'userAts'],
    data() {
        return {
            at: false,
            isCode: '',
            options: [],
            // selectionStart:'',//光标位置
            atLoading: true,
            atValue: '',
            userAt: [],
            selectionVal: ''
        };
    },
    methods: {

        async hangdleAt() {
            if (this.$store.state.token.token == undefined) return
            let res = await this.$global.userNotice()
            res.code == 200 ? (this.options = res.data, this.atLoading = false, this.at = !this.at, this.userAt = this.userAts) : this.at = false
        },
        handleOption(item) {
            this.at = false
            this.atValue = this.comments.slice(0, this.selectionStart) + '@' + item.nickname + this.comments.slice(this.selectionStart)
            let atNumber = this.comments.slice(0, this.selectionStart) + '@' + item.nickname
            this.selectionVal = atNumber.length
            this.userAt.push({ nickname: item.nickname, uid: item.uid })
            this.$emit('childEvent', this.atValue, this.userAt, this.selectionVal)
        }
    }
}
